<div fxLayout="column" fxLayoutGap="20px">
  <span dir="auto" *ngIf="!data.isApproval && !data.isBulk"
    class="textLarger regular">{{'are_you_sure_want_to_delete_this_request' | transloco}}</span>
  <span dir="auto" *ngIf="data.isApproval && !data.isBulk"
    class="textLarger regular">{{'are_you_sure_want_to_approve_this_request' | transloco}}</span>
  <span dir="auto" *ngIf="!data.isApproval && data.isBulk"
    class="textLarger regular">{{'are_you_sure_want_to_delete_this_requests' | transloco}}</span>
  <span dir="auto" *ngIf="data.isApproval && data.isBulk"
    class="textLarger regular">{{'are_you_sure_want_to_approve_this_requests' | transloco}}</span>
  <mat-form-field *ngIf="!data.isApproval">
    <mat-label dir="auto">{{'add_comment_optional' | transloco}}</mat-label>
    <input matInput [(ngModel)]="inputText" />
  </mat-form-field>
  <span fxLayoutGap="30px" fxLayoutAlign="center center" fxLayout="row">
    <button color="primary" ngStyle.xs="width:100px;font-size:15px;height:35px" mat-flat-button
      class="cancel-button medium" (click)="onAction(false)">{{'cancel' | transloco}}</button>
    <button color="primary" ngStyle.xs="width:100px;font-size:15px;height:35px" mat-stroked-button
      class="ok-button medium" (click)="onAction(true)">{{'ok' | transloco}}</button>
  </span>
</div>
